// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`CustomSelect test Match con el snapshot 1`] = `""`;
